import { getVacancy } from '../../services';
import { getCustomField, isCountryVacancyRelated } from '../utils/vacancies';

export const getVacancyForCountry = async (id, countryCode) => {
    const data = await getVacancy(id, countryCode);

    const vacancyCountryCodes = getCustomField(data, 'countries').filter(Boolean);
    const [initialCountryCode] = vacancyCountryCodes;

    if (!isCountryVacancyRelated(vacancyCountryCodes, countryCode)) {
        return getVacancy(id, initialCountryCode.toLowerCase());
    }

    return data;
};
